/**
 * Calculate the average rating from an array of review entities.
 *
 * @param {Array} reviews - An array of review entities
 * @returns {number | null} - The average rating rounded to 1 decimal place, or null if no reviews
 */
export const getAverageRating = reviews => {
  if (!reviews || !Array.isArray(reviews) || reviews.length === 0) {
    return null;
  }

  const totalRating = reviews.reduce((sum, review) => {
    const rating = review.attributes.rating;
    return sum + (rating || 0);
  }, 0);

  const average = totalRating / reviews.length;
  return Math.round(average * 10) / 10;
};
